import {Card} from "@elcimai/webankdesignsystem";
import React from "react";
import {
    CardImage,
    CardStyleSimplified,
    CardText,
    CardTitle,
    FlexStart,
    FlexWrap,
    ItemButton,
    ItemLayout
} from "./StoreItem.css";

export interface StoreItemProps {
    title: string,
    description: string,
    onClick: () => void,
    imageUrl: string,
}



const StoreItem = ({title, imageUrl, description, onClick}:StoreItemProps) => {
    return (
        <Card className={CardStyleSimplified} shadow={true}>
            <div className={ItemLayout}>
                <div className={FlexWrap}>
                    <img className={CardImage} src={imageUrl} alt={"Logo"}/>
                    <div className={FlexStart}>
                        <p className={CardTitle}>{title}</p>
                        <p className={CardText}>{description}</p>
                    </div>
                </div>
                <button className={ItemButton} onClick={onClick}>En savoir plus</button>
            </div>
        </Card>
    )
}


export default StoreItem;